import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

import AuthContext from './AuthContext';

export default function withAuth(WrappedComponent) {
  const Comp = props => (
    <AuthContext.Consumer>
      {auth => {
        return <WrappedComponent auth={auth} {...props} />;
      }}
    </AuthContext.Consumer>
  );
  return hoistNonReactStatics(Comp, WrappedComponent);
}
